import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable, inject } from '@angular/core';

import { Observable, finalize } from 'rxjs';

import { MpsLoaderService } from '../services/mps-loader.service';
import { SKIP_LOADER } from './skip-loader.token';

@Injectable()
export class mpsLoaderInterceptor implements HttpInterceptor {
  private loaderService = inject(MpsLoaderService);

  constructor(@Inject('LOADER_ON_HTTP') private loaderOnHttp: string) {}

  intercept(req: HttpRequest<unknown>, handler: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!this.loaderOnHttp || req.context.get(SKIP_LOADER)) {
      return handler.handle(req);
    }

    const id = this.loaderService.generateRandomId();
    this.loaderService.showLoader(id);
    return handler.handle(req).pipe(finalize(() => this.loaderService.hideLoader(id)));
  }
}
